export default __webpack_public_path__ + "static/media/ice.bc04c35d.jpg";